import * as React from "react";
import { useParams } from "react-router-dom";
import { normalizeLocale } from "../../utils/locales";
import { getPropertyBySlug } from "../../api/properties";
import PropertyDetailsClient from "components/properties/PropertyDetailsClient";
import { locales } from "i18n/locales";

export default function PropertyDetailsPage() {
  const { locale, slug } = useParams<{ locale?: string; slug?: string }>();
  const loc = normalizeLocale(locale);

  const [p, setP] = React.useState<any | null>(null);
  const [loading, setLoading] = React.useState(true);
  const [err, setErr] = React.useState<string | null>(null);

  React.useEffect(() => {
    let alive = true;

    (async () => {
      try {
        setLoading(true);
        setErr(null);

        if (!slug) {
          if (!alive) return;
          setP(null);
          return;
        }

        const res = await getPropertyBySlug(slug);
        if (!alive) return;

        setP(res ?? null);
      } catch (e: any) {
        if (!alive) return;
        setErr(e?.message ?? "Failed to load property");
        setP(null);
      } finally {
        if (!alive) return;
        setLoading(false);
      }
    })();

    return () => {
      alive = false;
    };
  }, [slug, locale]);

  if (loading) {
    return <div style={{ padding: 24 }}>Loading...</div>;
  }

  if (err) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Error</h2>
        <p>{err}</p>
      </div>
    );
  }

  if (!p) {
    return (
      <div style={{ padding: 24 }}>
        <h2>Not found</h2>
        <p>Δεν βρέθηκε ακίνητο για slug: {slug}</p>
      </div>
    );
  }

  return <PropertyDetailsClient locale={loc} p={p} />;
}
